import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import {
	adminGetSpecialRegime,
	adminGetAllSpecialRegimes,
	resetFocusSpecialRegime,
    initNewSpecialRegime,
    adminPatchSpecialRegime,
	adminPostSpecialRegime,
	adminDeleteSpecialRegime
} from 'services/specialRegime';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/SpecialRegimes/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	name: Yup.string().required('Champ requis'),
	acronym: Yup.string().required('Champ requis'),
	geslab_id: Yup.string().required('Champ requis'),
});

class SpecialRegimesAdmin extends Component {
	

	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusSpecialRegime();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllSpecialRegimes();
	};

	focusOnElement = elt => {
		this.props.adminGetSpecialRegime(elt);
	};

	onAddClick = () => {
		this.props.initNewSpecialRegime();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostSpecialRegime(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchSpecialRegime(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteSpecialRegime(this.props.specialRegimes.focus.data);
	};

	render() {
		const { specialRegimes } = this.props;
		const { focus, list } = specialRegimes;
		const specialRegime = focus.data;
		const newSpecialRegime = specialRegime !== null && specialRegime.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={specialRegimes.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity='RÉGIME SPÉCIAUX'
					addButtonText='Nouveau régime'
					onAddButtonClick={this.onAddClick}
					defaultLabel={e => e.name}
					groupField={false}
					focusedEltId={specialRegime}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity='Régimes spéciaux'
					icon='info'
				>
					{specialRegime !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: specialRegime.id,
								name: specialRegime.name || '',
								acronym: specialRegime.acronym || '',
								geslab_id: specialRegime.geslab_id || '',
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusSpecialRegime}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newSpecialRegime ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newSpecialRegime && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={e => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex'
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0'
	}
};

const mapStateToProps = state => {
	return {
		specialRegimes: state.admin.specialRegimes
	};
};

const mapDispatchToProps = {
	adminGetAllSpecialRegimes,
	adminGetSpecialRegime,
	adminPatchSpecialRegime,
	adminDeleteSpecialRegime,
	resetFocusSpecialRegime,
	adminPostSpecialRegime,
	initNewSpecialRegime
};

export default connect(mapStateToProps, mapDispatchToProps)(SpecialRegimesAdmin);
